import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "@/views/home/HomeView.vue";
import BlankLayout from "@/layouts/BlankLayout.vue";
import AdminHomeView from "@/views/admin/AdminHomeView.vue";
import ServiceHallLayout from "@/views/serviceHall/layout/ServiceHallLayout";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: HomeView,
    redirect: "/home",
    meta: { title: "首页", keepAlive: true },
  },
  {
    path: "/home",
    name: "home",
    component: HomeView,
    redirect: "/home/message/index",
    meta: { title: "首页", keepAlive: true },
    children: [
      {
        path: "message/index",
        name: "MessageIndex",
        component: () => import("@/views/home/messenger/MessageIndex.vue"),
        meta: { title: "消息", keepAlive: true },
      },
      {
        path: "contacts/index",
        name: "ContactsIndex",
        component: () => import("@/views/home/contacts/ContactsIndex.vue"),
        meta: { title: "通讯录", keepAlive: true },
      },
      {
        path: "workplace/index",
        name: "WorkHomeIndex",
        component: () => import("@/views/home/workplace/WorkplaceHomeView.vue"),
        meta: { title: "工作台", keepAlive: true, type: "app" },
      },
      {
        path: "person/index",
        name: "PersonIndex",
        component: () => import("@/views/home/person/PersonIndex.vue"),
        meta: { title: "个人中心", keepAlive: true },
      }
    ],
  },
  {
    path: "/admin",
    name: "AdminIndex",
    component: AdminHomeView,
    redirect: "/admin/app/index",
    meta: { requiresAdmin: true },
    children: [
      {
        path: "home",
        name: "AdminHome",
        redirect: "/admin/home/index",
        component: BlankLayout,
        meta: { title: "首页", keepAlive: true, requiresAdmin: true },
        children: [
          {
            path: "index",
            name: "AdminHomeIndex",
            component: () => import("@/views/admin/home/AdminHome.vue"),
            meta: { title: "首页", keepAlive: true },
          }
        ],
      },
      {
        path: "contacts/index",
        name: "ContactsAdminIndex",
        component: () => import("@/views/admin/contacts/ContactsAdminIndex.vue"),
        meta: { title: "通讯录", keepAlive: true },
        children: [
          {
            path: "org",
            name: "ContactsOrg",
            component: () => import("@/views/admin/contacts/OrgIndex.vue"),
            meta: { title: "组织机构", keepAlive: true },
          },
          {
            path: "emp",
            name: "ContactsEmp",
            component: () => import("@/views/admin/contacts/EmployeeIndex.vue"),
            meta: { title: "教职工管理", keepAlive: true },
          },
          {
            path: "parents",
            name: "ContactsParents",
            component: () => import("@/views/admin/contacts/ParentsIndex.vue"),
            meta: { title: "家长管理", keepAlive: true },
          },
          {
            path: "parents/bind/student",
            name: "ParentsBindStudent",
            component: () => import("@/views/admin/contacts/ParentsBindStudentList.vue"),
            meta: { title: "绑定学生", keepAlive: true },
          },
        ],
      },
      {
        path: "app",
        name: "AppCenter",
        redirect: "/admin/app/index",
        component: BlankLayout,
        meta: { title: "应用中心", keepAlive: true },
        children: [
          {
            path: "index",
            name: "AppAdminIndex",
            component: () => import("@/views/admin/app/AdminAppView.vue"),
            meta: { title: "应用中心", keepAlive: true },
          }
        ],
      },
      {
        path: "company",
        name: "CompanyAdminView",
        component: () => import("@/views/admin/company/CompanyAdminView.vue"),
        meta: { title: "我的单位", keepAlive: true },
        redirect: "/admin/company/config",
        children: [
          {
            path: "config",
            name: "CompanyConfig",
            component: () => import("@/views/admin/company/CompanyConfig.vue"),
            meta: { title: "单位信息", keepAlive: true },
          },
          {
            path: "perm",
            name: "PermConfig",
            component: () => import("@/views/admin/company/perm/PermConfig.vue"),
            meta: { title: "管理员权限", keepAlive: true },
          },
          {
            path: "groupPerm",
            name: "GroupPermConfig",
            component: () => import("@/views/admin/company/perm/GroupPermConfig.vue"),
            meta: { title: "管理员组管理", keepAlive: true },
          },
          {
            path: "workbench",
            name: "TeacherWorkbench",
            component: () => import("@/views/admin/company/workbench/WorkbenchList.vue"),
            meta: { title: "工作台管理", keepAlive: true },
          },
          {
            path: "dict",
            name: "DictType",
            component: () => import("@/views/dict/type/index.vue"),
            meta: { title: "数据字典", keepAlive: true },
          }
        ],
      },
    ],
  },
  {
    path: '/hall',
    component: ServiceHallLayout,
    redirect: '/service/hall',
    children: [
      {
        path: '/service/hall',
        name: 'serviceHall',
        component: () => import('@/views/serviceHall/ServiceHallIndex')
      }
    ]
  },
  {
    path: '/exception',
    name: 'exception',
    redirect: '/exception/403',
    component: BlankLayout,
    meta: { title: 'menu.exception', icon: 'warning', permission: ['exception'] },
    children: [
      {
        path: '/exception/403',
        name: 'ExceptionPage403',
        component: () => import(/* webpackChunkName: "fail" */ '@/views/exception/Page403.vue'),
        meta: { title: '403', permission: ['exception'] }
      },
      {
        path: '/exception/404',
        name: 'ExceptionPage404',
        component: () => import(/* webpackChunkName: "fail" */ '@/views/exception/Page404.vue'),
        meta: { title: '404', permission: ['exception'] }
      },
      {
        path: '/exception/500',
        name: 'ExceptionPage500',
        component: () => import(/* webpackChunkName: "fail" */ '@/views/exception/Page500.vue'),
        meta: { title: '500', permission: ['exception'] }
      }
    ]
  }
];

const createRouter = () =>
  new VueRouter({
    mode: "history",
    base: "/",
    routes,
  });

const router = createRouter();

const VueRouterPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(() => {
  });
};

// 定义一个resetRouter 方法，在退出登录后或token过期后 需要重新登录时，调用即可
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher;
}

export function get404Router() {
  return {
    path: '*',
    redirect: '/exception/404',
    hidden: true
  }
}

export default router;
